const { createSlice } = require('@reduxjs/toolkit');

const currencySlice = createSlice({
  name: "currency",
  initialState: {
    currencySymbol: "TSh",
    currencyName: "TZS",
    currencyRate: 1
  },
  reducers: {
    setCurrency(state, action) {
      const currencyName = action.payload;

      if (currencyName === "USD") {
        return {
          currencySymbol: "$",
          currencyRate: 1,
          currencyName
        };
      }

      if (currencyName === "TZS") {
        return {
          currencySymbol: "TSh",
          currencyRate: 1,
          currencyName
        };
      }
    }
  }
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;
